import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
} from "@fluentui/react-components";
import { MoreVertical16Regular } from "@fluentui/react-icons";
import { EditIcon } from "icons/EditIcon";
import { TrashIcon } from "icons/TrashIcon";
import { useSharedMenuStyles } from "theme/sharedStyles";
import { IProject } from "./projectCard.types";

export interface IProjectActionsMenuProps {
  project: IProject;
  onEdit: (project: IProject) => void;
  onDelete: (project: IProject) => void;
}

export const ProjectActionsMenu = (
  props: IProjectActionsMenuProps,
): JSX.Element => {
  const { project, onEdit, onDelete } = props;
  const sharedMenuStyles = useSharedMenuStyles();

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <Button
          icon={<MoreVertical16Regular />}
          appearance="subtle"
          size="small"
          aria-label="Project actions"
        />
      </MenuTrigger>
      <MenuPopover className={sharedMenuStyles.surface}>
        <MenuList>
          <MenuItem
            icon={
              <span className={sharedMenuStyles.itemIcon}>
                <EditIcon size={16} />
              </span>
            }
            onClick={() => onEdit(project)}
          >
            Edit
          </MenuItem>
          <MenuItem
            icon={
              <span className={sharedMenuStyles.itemIconDanger}>
                <TrashIcon size={16} />
              </span>
            }
            className={sharedMenuStyles.itemDanger}
            onClick={() => onDelete(project)}
          >
            Delete
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
